<template>
  <div class="answer-content">
    <div class="inner-header">
      <span class="title">答题卡</span>
      <div class="tip">
        <span>当前<i class="finish" :style="'background-color: ' + theme.themeColor"></i></span>
        <span>已答<i class="current" :style="'background-color: ' + theme.themeColor"></i></span>
        <span>未答<i class="not-yet" :style="'border: 1px solid' + theme.themeColor"></i></span>
      </div>
    </div>
    <div class="answer-progress">
      <p><span>答题进度</span><span>{{ totalFinish }}/{{ questionNum }}</span></p>
      <div class="progress-line" :style="'background-color: ' + theme.themeColor">
        <div class="current-progress" :style="'width:' + progressWidth + ';background-color:' + theme.themeColor">
          <i class="point" :style="'border: 3px solid ' + theme.themeColor"></i>
        </div>
      </div>
      <div class="test-info">共{{ questionNum }}题，满分{{ totalScore }}分</div>
    </div>
    <div class="scroll-box">
      <div class="select-content" v-for="[key, list] of group" :key="key">
        <span class="select-box" @click="toggleCollapsed(key)">{{ collapsed[key] ? '+' : '-' }}</span>
        <p class="question-type">{{ formateType(key, list[0].questionType) }}</p>
        <ul class="question-list" :class="{ 'collapsed': collapsed[key] }">
          <li v-for="el in list" :key="el.questionId" class="item"
            :class="{ 'clickDisable': !switchQuestionEnabled, 'is-finish': el.done }" :style="setStateStyle(el)"
            @mouseenter="(event) => styleChange(event, el, true)" @mouseleave="(event) => styleChange(event, el)"
            @click="selectQuestion(el.questionId)">{{ el.questionNo }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'
import { formateQuesType } from '@/utils/common'
import groupBy from 'lodash/groupBy'

export default {
  props: {
    questionList: {
      type: Array,
      default() {
        return []
      }
    },
    currentQuestion: {
      type: Object,
      default() {
        return {}
      }
    },
    switchQuestionEnabled: {
      type: Boolean,
      default: true
    },
    totalFinish: {
      type: Number,
      default: 0
    },
    totalScore: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      collapsed: {}, // 展开折叠
      currentId: Number(localStorage.getItem('currentQuestionId'))
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme
    },
    group() {
      let data = groupBy(this.questionList, 'typeId')
      data = Object.entries(data)
      data.sort((a, b) => a[1][0].questionNo - b[1][0].questionNo)
      return data
    },
    questionNum() {
      return this.questionList.length
    },
    // 答题进度
    progressWidth() {
      const width = this.totalFinish * 280 / this.questionNum
      return width + 'px'
    }
  },
  watch: {
    currentQuestion(value) {
      if (value.questionId) {
        this.currentId = value.questionId
        localStorage.setItem('currentQuestionId', value.questionId)
      }
    }
  },
  methods: {
    toggleCollapsed(key) {
      this.$set(this.collapsed, key, !this.collapsed[key])
    },
    selectQuestion(questionId) {
      if (!this.switchQuestionEnabled) return

      // 如果不是操作题，做保存动作
      if (![10, 11, 12].includes(this.currentQuestion.typeId)) {
        eventBus.$emit('saveQuestion', this.currentQuestion.questionId)
      }
      this.$emit('changeQuestion', {
        which: 'selectQuestion',
        currentId: questionId
      })
    },
    styleChange(e, el, theme) {
      if (el.done || this.currentId === el.questionId) return
      if (theme) {
        e.target.style = `border: 1px solid ${this.theme.themeColor}`
      } else {
        e.target.style = `border: 1px solid ${this.theme.lightThemeColor}`
      }
    },
    setStateStyle(el) {
      if (this.currentId === el.questionId) {
        return `border: 1px solid ${this.theme.themeColor}color: #fff; background-color: ${this.theme.themeColor}!important`
      }
      if (el.done) {
        return `background-color: ${this.theme.lightThemeColor}border: none; color: #666;`
      }
      return `border: 1px solid ${this.theme.lightThemeColor}`
    },
    formateType(id, questionType = 5) {
      return formateQuesType(Number(id), questionType)
    }
  }
}
</script>

<style lang="scss" scoped>
.answer-content {
  width: 360px;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, .1);
  border-radius: 8px 8px 0 0;
  padding: 20px;
  position: relative;
  margin-right: 20px;
  overflow: hidden;

  .scroll-box {
    position: relative;
    height: calc(100% - 190px);
    overflow: scroll;
    padding-bottom: 82px;

    &::-webkit-scrollbar {
      width: 10px;
      height: 1px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #666;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7f7f7;
    }
  }
}

.inner-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #f2f7ff;
  margin-bottom: 20px;

  .title {
    font-size: 24px;
    font-weight: 500;
    color: #333;
    line-height: 32px;
  }

  .tip {
    width: 172px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-size: 12px;
      color: #666;
      display: flex;
      align-items: center;

      i {
        margin-left: 5px;
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 2px;

        &.current {
          background-color: #E8F3FF;
          opacity: 0.15;
        }

        &.not-yet {
          border: 1px solid #dbe7f5;
          opacity: 0.15;
        }
      }
    }
  }
}

.answer-progress {
  width: 100%;
  background-color: #FAFAFA;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    margin-bottom: 12px;

    span:nth-of-type(1) {
      font-size: 18px;
      line-height: 24px;
    }

    span:nth-of-type(2) {
      font-size: 16px;
    }
  }

  .progress-line {
    position: relative;
    width: 100%;
    height: 2px;
    // background-color: rgba(55, 126, 253, .5);
    border-radius: 1px;
    margin-bottom: 12px;

    .current-progress {
      position: absolute;
      top: 50%;
      z-index: 1;
      transform: translateY(-50%);
      left: 0;
      width: 100px;
      height: 4px;
      // background-color: #377efd;
      border-radius: 2px;
      transition: width .3s linear;

      .point {
        position: absolute;
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 4px;
        border-radius: 50%;
        box-sizing: content-box;
        // border: 3px solid #377efd;
        background-color: #fff;
      }
    }

    &::after {
      position: absolute;
      content: '';
      background: rgba(235, 229, 229, 0.7);
      width: 100%;
      height: 2px;
      top: 0;
    }
  }

  .test-info {
    font-size: 14px;
    line-height: 20px;
    color: #333;
  }
}

.select-content {
  padding-left: 25px;
  width: 260px;
  position: relative;

  .select-box {
    position: absolute;
    top: 5px;
    left: 0;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: #fff;
    font-size: 14px;
    color: rgba(0, 0, 0, .65);
    border: 1px solid rgba(0, 0, 0, .15);
    line-height: 12px;
    text-align: center;
    cursor: pointer;
    font-weight: 300;

    &:hover {
      border: 1px solid $themeColor;
      color: $themeColor;
    }
  }

  .question-type {
    font-size: 18px;
    color: #333;
    line-height: 25px;
    margin-bottom: 20px;
  }

  .question-list {
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    align-items: center;

    &.collapsed {
      height: 0;
    }

    .item {
      position: relative;
      width: 32px;
      height: 32px;
      border-radius: 2px;
      background-color: #fff;
      border: 1px solid #DBE7F5;
      font-size: 14px;
      line-height: 30px;
      color: #666;
      text-align: center;
      margin-right: 15px;
      margin-bottom: 15px;
      cursor: pointer;

      &:nth-of-type(5n) {
        margin-right: 0;
      }

      &.is-finish {
        &.is-current {
          background-color: rgba(57, 126, 253, .6);
          color: #666;
        }
      }
    }

    .clickDisable {
      color: #999999;
      background: #F7F7F7;
      border: 1px solid #D0D0D0 !important;
      cursor: not-allowed !important;
      box-shadow: none !important;
    }
  }
}
</style>
